module.exports = __webpack_public_path__ + "static/media/icon_playing.7d6d7cf9.svg";